import React from 'react'

const HomeBg = ({className}) => {
    return (
        <svg className={className} width="500" height="500" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0)">
                <rect width="100" height="100" fill="#1D70BC" />
                <g filter="url(#filter0_d)">
                    <path d="M41 0H100V92V92C95.8096 88.1319 93.1651 82.8747 92.5576 77.2044L92.4727 76.4117C92.1599 73.4922 92.3502 70.5407 93.0355 67.6856L93.3276 66.4684C94.4296 61.8766 94.5307 57.1014 93.624 52.4671L91.5675 41.9563C90.8612 38.3463 89.5321 34.8868 87.6395 31.7325V31.7325C83.682 25.1367 77.4616 20.2047 70.1372 17.8553L64.847 16.1585C58.3617 14.0783 52.413 10.5978 47.4221 5.96337L41 0Z" fill="#45A6FF" />
                </g>
            </g>
            <defs>
                <filter id="filter0_d" x="17" y="-20" width="107" height="140" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="12" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
                <clipPath id="clip0">
                    <rect width="100" height="100" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default HomeBg
